/*
 * This script replaces the cart text that comes from App: Pay What You Want
 */

(function() {
  // Execute only on cart page
  if (!window.location.pathname.includes('/cart')) return;
  
  function replaceText() {
    // Find all elements containing text
    const allElements = document.getElementsByTagName('*');
    
    for (let element of allElements) {
      // Check if element contains "Your Price"
      if (element.innerHTML && element.innerHTML.includes('Your Price')) {
        // Replace in HTML content
        element.innerHTML = element.innerHTML.replace(/Your Price/g, 'Lahjakortin arvo');
      }
    }
  }
  
  // Wait for page to load
  setTimeout(function() {
    replaceText();
  }, 1500); // 1.5 second delay
  
  // Try also on DOM ready
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(replaceText, 500);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(replaceText, 500);
    });
  }
})();